import { IconProps } from './types';

export const CarIcon = ({ title = 'Car Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="31" fill="none" viewBox="0 0 35 31" {...props}>
        <title>{title}</title>
        <circle cx="8.5" cy="18.5" r="3.5" fill="#FB0"></circle>
        <circle cx="26.5" cy="18.5" r="3.5" fill="#FB0"></circle>
        <path
            fill="#0A2F73"
            d="M5.833 27.125v1.938q0 .823-.559 1.38Q4.716 31 3.89 31H1.944q-.825 0-1.385-.557T0 29.063v-15.5L4.083 1.938A2.75 2.75 0 0 1 5.128.533 2.84 2.84 0 0 1 6.806 0h21.388q.924 0 1.678.533.753.532 1.045 1.405L35 13.563v15.5q0 .823-.559 1.38-.56.557-1.385.557H31.11q-.826 0-1.385-.557-.56-.557-.56-1.38v-1.938zM5.444 9.688h24.112l-2.042-5.813H7.486zM8.75 21.313q1.215 0 2.066-.848.85-.847.85-2.059 0-1.21-.85-2.058A2.82 2.82 0 0 0 8.75 15.5q-1.215 0-2.066.848a2.8 2.8 0 0 0-.85 2.058q0 1.212.85 2.059a2.82 2.82 0 0 0 2.066.848m17.5 0q1.215 0 2.066-.848.85-.847.85-2.059 0-1.21-.85-2.058a2.82 2.82 0 0 0-2.066-.848q-1.215 0-2.066.848a2.8 2.8 0 0 0-.85 2.058q0 1.212.85 2.059a2.82 2.82 0 0 0 2.066.848"
        ></path>
    </svg>
);
